<div class="w-[80vh] h-[80vh] flex flex-col">
  <div class="h-10 border-b">
    <div class="w-full flex justify-between">
      <div class="text-2xl font-bold">Report Details</div>
      <confect-icon-button
        icon="clear"
        iconClass="hover:opacity-80 text-3xl"
        (click)="close.emit()"
      />
    </div>
  </div>
  <div
    class="flex flex-col w-full overflow-auto space-y-5"
    [style.height]="'calc(100% - 2.5rem)'"
  >
    @for (error of errors(); track error.type) {
      <ngx-feed-status-issue [issues]="error" />
    }
    @for (warning of warnings(); track warning.type) {
      <ngx-feed-status-issue [issues]="warning" type="warning" />
    }
  </div>
</div>
